


















































































import tm_MenuItem from '@/components/other/tm-menu-item.vue';
import tm_MenuItemPage from '@/components/pages/tm-menu-item-page.vue';
import tm_FiltersPage from '@/components/pages/tm-filters-page.vue';
import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';
import * as Constants from '@/constants.ts';
import firebase from 'firebase/app';
import Vue from 'vue';

export default Vue.extend({
  components: {
    'tm-menu-item': tm_MenuItem,
    'tm-menu-item-page': tm_MenuItemPage,
    'tm-filters-page': tm_FiltersPage,
  },
  data() {
    return {
      isLoading: true,
      isFullNav: false,
      eAttributeSelectionTypes: Enums.eAttributeSelectionTypes,
      allRoutes: Constants.allRoutes,
    };
  },
  mounted() {
    Util.eventBus.$on('menuTranslationUpdated', () => {
      this.$forceUpdate();
    });
  },
  computed: {
    isKioskMode(): boolean {
      return this.$store.state.isKioskMode;
    },
    currentClientUser(): ClientUser {
      return this.$store.state.currentClientUser;
    },
    menuSelectionPossible(): boolean {
      return this.$store.state.menuSelectionPossible;
    },
    promotion(): Promotion {
      return this.$store.state.currentLocation.promotion;
    },
    isViewOnlyMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.viewOnly;
    },
    numberOfOrders(): string {
      return this.$store.state.toBeSentOrders.length ? this.$store.state.toBeSentOrders.length.toString() : '';
    },
    attributeFiltersInUse(): any[] {
      const attributes: any = this.filters.selectedAttributes;
      return Object.keys(attributes)
        .filter((key: string) => {
          return attributes[key] === this.$data.eAttributeSelectionTypes.positive || attributes[key] === this.$data.eAttributeSelectionTypes.negative; // checking if null or undefined.
        })
        .map((key: string) => {
          return {
            label: Util.camelToTitleCase(key),
            val: attributes[key],
            onClick: () => {
              this.$store.commit('setFilterObject', {
                ...this.$store.state.filters,
                selectedAttributes: {
                  ...this.$store.state.filters.selectedAttributes,
                  [key]: 0,
                },
              } as FilterObject);
            },
          };
        });
    },
    rangeFiltersInUse(): any[] {
      const ranges: any = this.filters.ranges;
      return Object.keys(ranges)
        .filter((key: string) => {
          const min = ranges[key][0];
          const max = ranges[key][1];
          return (min !== this.filters.lowestValues[key] && min !== 0) || (max !== this.filters.highestValues[key] && max !== Number.MAX_SAFE_INTEGER);
        })
        .map((key: string) => {
          return {
            label: Util.camelToTitleCase(key),
            min: Math.round(ranges[key][0]),
            max: Math.round(ranges[key][1]),
            onClick: () => {
              this.$store.commit('setFilterObject', {
                ...this.$store.state.filters,
                ranges: {
                  ...this.$store.state.filters.ranges,
                  [key]: [this.filters.lowestValues[key] || 0, this.filters.highestValues[key] || Number.MAX_SAFE_INTEGER],
                },
              } as FilterObject);
            },
          };
        });
    },
    filters(): FilterObject {
      return this.$store.state.filters;
    },
    categories(): MenuCategory[] {
      const ret = this.$store.state.currentMenu.categories
        .map((cat: MenuCategory) => {
          return {
            ...Constants.EMPTY_MENU_CATEGORY,
            ...cat,
            menuItems: this.filterMenuItems(cat),
          };
        })
        .filter((cat: MenuCategory) => cat.menuItems.length);

      return Util.getResourceArrayWithValidTimeslotsAndVisible(ret) as MenuCategory[];
    },
    showNoMenuItemsDisclaimer(): boolean {
      return !this.categories
        ? false
        : !this.categories.some((category: MenuCategory) => {
            return Boolean(this.filterMenuItems(category).length);
          });
    },
  },
  methods: {
    routerPush(args: any) {
      Util.routerPush(args);
    },
    translatedName(category: MenuCategory): string {
      return Util.getTranslatedField(category, 'name');
    },
    translatedDescription(category: MenuCategory): string {
      return Util.getTranslatedField(category, 'description');
    },
    signOut() {
      Util.signOut();
    },
    showPromotionModal() {
      Util.rootComponent.showPromotionModalFunc();
    },
    filterMenuItems(category: MenuCategory): MenuItem[] {
      const ret: MenuItem[] = category.menuItems.filter((mi: MenuItem) => {
        const allPositiveAttributes = Object.keys(this.filters.selectedAttributes).filter((attr: string) => {
          return (this.filters.selectedAttributes as any)[attr] === this.$data.eAttributeSelectionTypes.positive;
        });
        const allNegativeAttributes = Object.keys(this.filters.selectedAttributes).filter((attr: string) => {
          return (this.filters.selectedAttributes as any)[attr] === this.$data.eAttributeSelectionTypes.negative;
        });

        // Note: Right now only positive selections are possible but leaving this code as is in case we want to revert.
        const hasAsingleFalsePositiveAttribute = allPositiveAttributes.some((attr: string): boolean => {
          const val = (mi as any)[`is${Util.capitalizeFirstLetter(attr)}`];
          return val !== true && !(val === null && this.filters.showIndeterminate);
        });
        const hasAsingleTrueNegativeAttribute = allNegativeAttributes.some((attr: string): boolean => {
          const val = (mi as any)[`is${Util.capitalizeFirstLetter(attr)}`];
          return val !== false && !(val === null && this.filters.showIndeterminate);
        });

        const everythingWithinRange = Constants.FOOD_VALUES.every((val: string): boolean => {
          let selectedVal: number = Number((mi as any)[val]);
          if (val === 'temperature') {
            selectedVal = Util.enumKeyNumValue(mi[val], Enums.eTemperatures);
          }
          if (isNaN(selectedVal)) {
            // This is useful in case database values are changed. We can accept menu items that don't have all of their values set.
            return true;
          }
          return selectedVal >= this.filters.ranges[val][0] && selectedVal <= this.filters.ranges[val][1];
        });
        return !hasAsingleFalsePositiveAttribute && !hasAsingleTrueNegativeAttribute && everythingWithinRange;
      });

      return Util.getResourceArrayWithValidTimeslotsAndVisible(ret) as MenuItem[];
    },
    showFilterPageFunc() {
      (this.$refs.filterPage as any).reset();
      Util.routerPush({ path: Constants.allRoutes.filtersModal });
    },
    showMenuInfoPageFunc(menuItem: MenuItem) {
      (this.$refs.menuItemPage as any).reset();
      Util.routerPush({ path: Constants.allRoutes.menuItemModal });
      (this.$refs.menuItemPage as any).initialize();
    },
  },
});
